import { Typography } from '@scale/scaleui';
import { HomeViewCard } from './HomeViewCard';
import { IconName } from '@fortawesome/free-solid-svg-icons';

interface SectionProps {
  title: string;
  items: Array<{
    key: string;
    title: string;
    description: string;
    icon: IconName;
    to: string;
  }>;
}

export function Section({ title, items }: SectionProps) {
  return (
    <div className="space-y-6">
      <Typography.H2 className="text-[rgba(2,0,8,0.8784)] text-xl font-medium tracking-[-0.1px] leading-[30px] font-inter">
        {title}
      </Typography.H2>
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4 gap-6">
        {items.map(({ key, ...otherProps }) => (
          <HomeViewCard key={key} {...otherProps} />
        ))}
      </div>
    </div>
  );
}
